import { render, staticRenderFns } from "./LicenseSetting.vue?vue&type=template&id=3f5459b6"
import script from "./LicenseSetting.vue?vue&type=script&lang=js"
export * from "./LicenseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports